import { z } from 'zod';
import { NAME_MAX_LENGTH } from '../utils';

const MeasurementModel = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
});

export const MeasurementsModel = MeasurementModel.array();

export const IndicatorMeasurementFormSchema = z.object({
  name: MeasurementModel.shape.name.max(NAME_MAX_LENGTH),
});

export const UpdateIndicatorMeasurementRequestParamSchema = MeasurementModel;

export const DeleteIndicatorMeasurementRequestParamSchema =
  MeasurementModel.pick({
    id: true,
  });
